"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCheckbox = void 0;
const ButtonBase_1 = require("@mui/material/ButtonBase");
const FormControlLabel_1 = require("@mui/material/FormControlLabel");
const SvgIcon_1 = require("@mui/material/SvgIcon");
const styles_1 = require("@mui/material/styles");
const checkbox_1 = __importDefault(require("../checkbox"));
exports.StyledCheckbox = (0, styles_1.styled)(checkbox_1.default)(({ theme }) => ({
    [`.${FormControlLabel_1.formControlLabelClasses.root}`]: {
        marginRight: 0,
        marginLeft: 0
    },
    [`.${SvgIcon_1.svgIconClasses.root}`]: {
        width: "24px",
        height: "24px"
    },
    [theme.breakpoints.down("lg")]: {
        [`.${ButtonBase_1.buttonBaseClasses.root}`]: {
            padding: 0
        }
    }
}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2Rvd25sb2FkLWxpc3Qvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7OztBQUFBLHlEQUE2RDtBQUM3RCxxRUFBeUU7QUFDekUsbURBQXVEO0FBQ3ZELGlEQUE4QztBQUM5QywyREFBbUM7QUFFdEIsUUFBQSxjQUFjLEdBQUcsSUFBQSxlQUFNLEVBQUMsa0JBQVEsQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUM3RCxDQUFDLElBQUksMENBQXVCLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtRQUNwQyxXQUFXLEVBQUUsQ0FBQztRQUNkLFVBQVUsRUFBRSxDQUFDO0tBQ2Q7SUFDRCxDQUFDLElBQUksd0JBQWMsQ0FBQyxJQUFJLEVBQUUsQ0FBQyxFQUFFO1FBQzNCLEtBQUssRUFBRSxNQUFNO1FBQ2IsTUFBTSxFQUFFLE1BQU07S0FDZjtJQUNELENBQUMsS0FBSyxDQUFDLFdBQVcsQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtRQUM5QixDQUFDLElBQUksOEJBQWlCLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtZQUM5QixPQUFPLEVBQUUsQ0FBQztTQUNYO0tBQ0Y7Q0FDRixDQUFDLENBQUMsQ0FBQyJ9